import { DataType } from '@labrav/react-components/lib/@types/types/forms'

export const specifiedMonthField = {
  title: 'Specified Month',
  humanReadableKey: 'Specified Month',
  placeHolder: 'Specified Month',
  id: 'offerStartDate',
  isRequired: true,
  isReadOnly: false,
  isCustom: false,
  dataType: 'date',
}

export const startDateTypeField = {
  title: 'Start date',
  placeHolder: 'Start date',
  humanReadableKey: 'variableStartDate',
  id: 'variableStartDate',
  isReadOnly: false,
  isRequired: true,
  dataType: 'enum' as DataType,
  validationType: undefined,
  isCustom: false,
  options: [
    { label: 'Accepted date', value: 'isAccepted' },
    { label: 'Specified Month', value: 'isSpecified' },
  ],
}

export const endDateField = {
  title: 'End date',
  humanReadableKey: 'End date',
  placeHolder: 'End date',
  id: 'offerExpirationDate',
  isRequired: true,
  isReadOnly: false,
  isCustom: false,
  dataType: 'date',
}

export const azureOfferExpirationDateField = {
  title: 'Offer expiration date',
  humanReadableKey: 'Offer expiration date',
  placeHolder: 'Offer expiration date',
  id: 'acceptBy',
  isRequired: true,
  isReadOnly: false,
  isCustom: false,
  dataType: 'date',
}
